import { render, staticRenderFns } from "./DirectorDetails.vue?vue&type=template&id=f9e9ee84&scoped=true"
import script from "./DirectorDetails.vue?vue&type=script&lang=js"
export * from "./DirectorDetails.vue?vue&type=script&lang=js"
import style0 from "./DirectorDetails.vue?vue&type=style&index=0&id=f9e9ee84&prod&scoped=true&lang=css"
import style1 from "./DirectorDetails.vue?vue&type=style&index=1&id=f9e9ee84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e9ee84",
  null
  
)

export default component.exports